export const reduceAutomationTitles = val =>
    val
        .reduce((accumulator, current) => {
            accumulator.push(current.name || current.title || current.value)
            return accumulator
        }, [])
        .join(", ")

const reduceSelected = selected => {
    return reduceAutomationTitles(
        Object.values(selected).reduce((acc, curr) => {
            if (Array.isArray(curr)) {
                acc.push(...curr)
            }
            return acc
        }, [])
    )
}

export default {
    methods: {
        getDelayText(item) {
            const { delay, delay_option: option } = item

            let text = ``

            if (delay && delay.type === "delay_by_time" && option && option.timing) {
                if (option.timing.type === "wait_time") {
                    text += this.t("automation.opens_in")

                    if (option.timing.after_days) {
                        text += ` <b>${option.timing.after_days} ${this.t("automation.days").toLowerCase()}</b>`
                    }

                    if (option.timing.after_hours) {
                        text += ` <b>${option.timing.after_hours} ${this.t("automation.hours").toLowerCase()}</b>`
                    }

                    if (option.timing.after_minutes) {
                        text += ` <b>${option.timing.after_minutes} ${this.t("automation.minutes").toLowerCase()}</b>`
                    }
                }

                if (option.timing.type === "continue_on_specific_day_of_week") {
                    text += `${this.t("automation.will_open_in")} <b>${option.timing.day_of_week}</b>`
                }

                if (option.timing.type === "continue_on_specific_time") {
                    text += `${this.t("automation.will_open")} <b>${option.timing.date_at}</b>`
                }
            }

            if (delay.type === "delay_by_event" && option && option) {
                text += `${this.t("automation.when_event_fire")} "${this.getEventText(option)}"`
            }

            return text
        },
        getActionText(item) {
            const { action, action_option: option } = item

            let text = ``

            if (action && action.module_name) {
                text = `${action.module_name}  → `
            }

            if (action && action.group_name) {
                text += `${action.group_name}: `
            }

            if (action && action.name) {
                text += `<b>${action.name}</b>`
            }

            if (option && option.additional) {
                text += ` <span><i>${option.additional.name || option.additional.title}</i></span>`
            }

            if (option && option.name) {
                text += ` <span><b>${option.name}</b></span>`
            }

            if (option && option.hasOwnProperty("target")) {
                text += ` <span><i>${
                    option.target
                        ? option.target.name
                        : `${this.t("automation.on_project")} ${this.cabinet ? `"${this.cabinet.slug}"` : ""}`
                }</i></span>`
            }

            if (option && option.value && !option.is_reset_point) {
                text += ` <span><b>${option.value}</b></span>`
            }

            if (option && option.is_reset_point) {
                text += ` <span><b>${this.t("automation.reset_points")}</b></span>`
            }

            if (option && option.is_reset_point_by_event) {
                text += ` <span><b>${this.t("automation.reset_points")}</b></span>`
            }

            if (option && option.is_can_be_negative && !option.is_reset_point) {
                text += ` <span><b>${this.t("automation.without_negative")}</b></span>`
            }

            if (option && (option.after_month || option.after_days)) {
                text += `<span><i>${option.after_month ? `${option.after_month} ${this.t("automation.months")}` : ""} ${
                    option.after_days ? `${option.after_days} ${this.t("automation.days")}` : ""
                } </i></span>`
            }

            if (option && option.selected) {
                text += ` (${reduceSelected(option.selected)})`
            }

            if (option && option.method) {
                const fields = reduceAutomationTitles(option.fields)

                if (option.wh_url) {
                    text += ` <span>${option.method} → ${option.wh_url}` + (fields ? ` (${fields})` : "") + "</span>"
                } else {
                    text += ` <span>${this.t("contacts.fields")}` + (fields ? ` (${fields})` : "") + "</span>"
                }
            }

            if (option && option.address_book) {
                text += ` <span><i>book: ${option.address_book}</i></span>`
            }

            return text
        },
        getEventText(item) {
            const { event, event_option: option } = item

            let text = ``

            if (event && event.group_name) {
                text = `${event.group_name}  → `
            }

            if (event && event.module_name) {
                text += `${event.module_name}: `
            }

            if (event) {
                text += `<b>${event.name}</b>`
            }

            if (option && option.values && option.values.length) {
                text += ` <span><b>${option.values
                    .reduce((accumulator, current) => {
                        accumulator.push(current.name || current.value)
                        return accumulator
                    }, [])
                    .join(", ")}</b></span>`
            }

            if (option && option.hasOwnProperty("target")) {
                text += ` <span><i>${
                    option.target
                        ? option.target.name
                        : `${this.t("automation.on_project")} ${this.cabinet ? `"${this.cabinet.slug}"` : ""}`
                }</i></span>`
            }

            if (option && option.name) {
                text += ` <span><b>${option.name}</b></span>`
            } else if (option && option.value) {
                text += ` <span><b>${option.value}</b></span>`
            }

            if (option && option.additional) {
                text += ` <span><i>${option.additional.name || option.additional.title}</i></span>`
            }

            if (option && option.selected) {
                text += ` (${reduceSelected(option.selected)})`
            }

            return text
        },
        getConditionText(item) {
            const { condition, condition_option: option } = item
            let text = ``

            if (condition.module_name) {
                text = `${condition.module_name}  → `
            }
            if (condition.group_name) {
                text += `${condition.group_name}: `
            }
            text += `<b>${condition.name}</b>`

            if (option) {
                if (option && option.hasOwnProperty("target")) {
                    text += ` <span><i>${
                        option.target
                            ? option.target.name
                            : `${this.t("automation.on_project")} ${this.cabinet ? `"${this.cabinet.slug}"` : ""}`
                    }</i></span>`
                }
                if (option.access) {
                    text += ` <span><i>${option.access.event_condition_operator_name}</i></span>`
                }

                if (option.name && condition.entity_name === "contact_field") {
                    text += ` <span><b>${option.name}</b></span>`
                }

                if (option && option.selected) {
                    text += ` (${reduceSelected(option.selected)})`
                }

                if (option.has) {
                    if (Array.isArray(option.has)) {
                        text += ` <span><i>${option.has
                            .reduce((accumulator, current) => {
                                accumulator.push(current.event_condition_operator_name)
                                return accumulator
                            }, [])
                            .join(", ")}</i></span>`
                    } else {
                        text += ` <span><i>${option.has.event_condition_operator_name}</i></span>`
                    }
                }

                if (option.event_condition_operator_name && !option.interval?.event_condition_operator_name) {
                    text += ` <span><i>${option.event_condition_operator_name}</i></span>`
                }

                if (option.conformity) {
                    text += ` <span><i>${option.conformity.event_condition_operator_name}</i></span>`
                }

                if (option.find) {
                    text += ` <span><i>${option.find.event_condition_operator_name}</i></span>`
                }

                if (option.interval) {
                    text += ` <span><i>${option.interval.event_condition_operator_name || option.interval.name} ${
                        option?.time || ""
                    }</i></span>`
                }

                if (option.name && condition.entity_name !== "contact_field") {
                    text += ` <span><b>${option.name}</b></span>`
                } else if (option.value) {
                    text += ` <span><b>${option.value}</b></span>`
                }

                if (option.values) {
                    text += ` <span><b>${option.values
                        .reduce((accumulator, current) => {
                            accumulator.push(current.name)
                            return accumulator
                        }, [])
                        .join(", ")}</b></span>`
                }

                if (option && option.watch) {
                    text += ` <span><i>${option.watch.event_condition_operator_name}${
                        option.watch.event_condition_operator === "timeline"
                            ? `: ${this.t("automation.from")} <b>${option.watch?.from || 0}</b> ${this.t(
                                  "automation.to"
                              )}  <b>${option.watch?.to || 0}</b> ${this.t("quiz.minutes_1")}`
                            : ""
                    }</i></span>`
                }

                if (option.from && option.to) {
                    text += ` <span><i>${this.t("create-course.from")} ${option.from} ${this.t("create-course.to")} ${
                        option.to
                    }</i></span>`
                }
            }

            return text
        }
    },
    computed: {
        cabinet() {
            return this.$store.getters["user/cabinets"].find(c => c.is_current)
        }
    }
}
